import Vue from "vue";
import Router from "vue-router";
import store from "./../store/index";
import { routes } from "@/router/routes";

Vue.use(Router);

const roteador = new Router({
  mode: "history",
  routes
});

//Validador Guardião de Rotas

roteador.beforeEach((to, from, next) => {
  const url = to.path;

  if (url === "/compra") {
    let grupos = store.getters["usuario/getGrupos"];

    let objGrupo = {
      id: 0,
      descricao: "Todos Grupos",
      sigla: "TDS"
    };

    let filial_compra = localStorage.getItem("filial_compra");

    grupos.push(objGrupo);
    store.dispatch("usuario/setGrupos", grupos);

    if (from.fullPath != "/pedidos") {
      store.dispatch("usuario/setFilialCompras", 0);
    }

    if (filial_compra === "S") {
      store.dispatch("usuario/setExibeFilialCompra", true);
    }
  } else {
    let grupos = store.getters["usuario/getGrupos"];

    let existeGrupoTodos = false;

    grupos.forEach(g => {
      if (g.id == 0) existeGrupoTodos = true;
    });

    if (existeGrupoTodos) {
      grupos.pop();
    }

    let grupoSelecionado = store.getters["usuario/getGrupoCompras"];

    if (store.getters["usuario/getGrupoCompras"] == 0) {
      grupoSelecionado = 1;
    }

    store.dispatch("usuario/setGrupos", grupos);
    store.dispatch("usuario/setGrupoCompras", grupoSelecionado);
    store.dispatch("usuario/setExibeFilialCompra", false);
  }

  if (url !== "/") {
    if (`${url}`.substring(0, 16) === '/compras/grupos/') {
      next();
      return;
    }

    const rotas_perfil = (localStorage.urls || '').split(",");
    const url_aplicatico_valida = rotas_perfil.some(rota => rota.includes(url));

    if (!url_aplicatico_valida) {
      const itens = [
        "token",
        "nome",
        "service",
        "setor",
        "hash_acesso",
        "urls",
        "empresa"
      ];

      itens.forEach(item => localStorage.removeItem(item));

      alert("Aplicativo não habilitado no perfil.");

      next(false);
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

roteador.afterEach(() => {
  store.dispatch('filtrosUniversalAvancado/syncRota')
})

export default roteador;
